import { type Theme } from "@mui/material";
import { type Components } from "@mui/material/styles";

export const muiChipOverrides: Components<Theme> = {
  MuiChip: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiChip-icon, & .MuiChip-label, & .MuiTypography-root": {
          margin: 0,
          padding: 0,
        },

        "& > *:last-child:not(:only-child):not(:empty)": {
          marginLeft: theme.spacing(1),
        },

        "&.Mui-disabled": {
          opacity: 1,

          "& .MuiChip-icon": {
            color: theme.palette.intent?.disabled.icon,
          },

          "& .MuiChip-label, & .MuiTypography-root": {
            color: theme.palette.intent?.disabled.text,
          },
        },
      }),
      sizeSmall: ({ theme }: { theme: Theme }) => ({
        height: theme.size?.pill?.small,
        minHeight: theme.size?.pill?.small,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        // setting min width so just an icon is not circle shaped
        minWidth: `calc(${theme.size?.icon.small} + 2 * ${theme.spacing(3)})`,

        "& .MuiChip-label:not(:empty)": {
          fontSize: theme.typography.caption.fontSize,
          // when there is a label, we want additional padding to the right
          paddingRight: theme.spacing(2),

          "&:only-child": {
            // if there is only one child, we want padding on the left as well
            paddingLeft: theme.spacing(2),
          },
        },
      }),

      sizeMedium: ({ theme }: { theme: Theme }) => ({
        height: theme.size?.pill?.medium,
        minHeight: theme.size?.pill?.medium,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),

        "& .MuiChip-label": {
          fontSize: theme.typography.body2.fontSize,
        },
      }),
    },

    variants: [
      {
        props: { variant: "filled" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.background?.primary,

          "&.Mui-disabled": {
            color: theme.palette.intent?.disabled.text,
            backgroundColor: theme.palette.intent?.disabled.background,
          },
        }),
      },
      {
        props: { variant: "outlined" },
        style: ({ theme }) => ({
          borderWidth: theme.borderWidth?.thin,

          "&.Mui-disabled": {
            color: theme.palette.intent?.disabled.text,
            borderColor: theme.palette.intent?.disabled.border,
          },
        }),
      },
    ],
  },
};
